/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';



import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';



export class DxoCommonAxisSettingsComponent extends NestedOption {
    
    get allowDecimals(): boolean {
        return this._getOption('allowDecimals');
    }
    set allowDecimals(value: boolean) {
        this._setOption('allowDecimals', value);
    }

    
    get breakStyle(): any {
        return this._getOption('breakStyle');
    }
    set breakStyle(value: any) {
        this._setOption('breakStyle', value);
    }

    
    get color(): string {
        return this._getOption('color');
    }
    set color(value: string) {
        this._setOption('color', value);
    }

    
    get constantLineStyle(): any {
        return this._getOption('constantLineStyle');
    }
    set constantLineStyle(value: any) {
        this._setOption('constantLineStyle', value);
    }

    
    get discreteAxisDivisionMode(): string {
        return this._getOption('discreteAxisDivisionMode');
    }
    set discreteAxisDivisionMode(value: string) {
        this._setOption('discreteAxisDivisionMode', value);
    }

    
    get endOnTick(): boolean {
        return this._getOption('endOnTick');
    }
    set endOnTick(value: boolean) {
        this._setOption('endOnTick', value);
    }

    
    get grid(): any {
        return this._getOption('grid');
    }
    set grid(value: any) {
        this._setOption('grid', value);
    }

    
    get inverted(): boolean {
        return this._getOption('inverted');
    }
    set inverted(value: boolean) {
        this._setOption('inverted', value);
    }

    
    get label(): any {
        return this._getOption('label');
    }
    set label(value: any) {
        this._setOption('label', value);
    }

    
    get maxValueMargin(): number {
        return this._getOption('maxValueMargin');
    }
    set maxValueMargin(value: number) {
        this._setOption('maxValueMargin', value);
    }

    
    get minorGrid(): any {
        return this._getOption('minorGrid');
    }
    set minorGrid(value: any) {
        this._setOption('minorGrid', value);
    }

    
    get minorTick(): any {
        return this._getOption('minorTick');
    }
    set minorTick(value: any) {
        this._setOption('minorTick', value);
    }

    
    get minValueMargin(): number {
        return this._getOption('minValueMargin');
    }
    set minValueMargin(value: number) {
        this._setOption('minValueMargin', value);
    }

    
    get opacity(): number {
        return this._getOption('opacity');
    }
    set opacity(value: number) {
        this._setOption('opacity', value);
    }

    
    get placeholderSize(): number {
        return this._getOption('placeholderSize');
    }
    set placeholderSize(value: number) {
        this._setOption('placeholderSize', value);
    }

    
    get setTicksAtUnitBeginning(): boolean {
        return this._getOption('setTicksAtUnitBeginning');
    }
    set setTicksAtUnitBeginning(value: boolean) {
        this._setOption('setTicksAtUnitBeginning', value);
    }

    
    get stripStyle(): any {
        return this._getOption('stripStyle');
    }
    set stripStyle(value: any) {
        this._setOption('stripStyle', value);
    }

    
    get tick(): any {
        return this._getOption('tick');
    }
    set tick(value: any) {
        this._setOption('tick', value);
    }

    
    get title(): any {
        return this._getOption('title');
    }
    set title(value: any) {
        this._setOption('title', value);
    }

    
    get valueMarginsEnabled(): boolean {
        return this._getOption('valueMarginsEnabled');
    }
    set valueMarginsEnabled(value: boolean) {
        this._setOption('valueMarginsEnabled', value);
    }

    
    get visible(): boolean {
        return this._getOption('visible');
    }
    set visible(value: boolean) {
        this._setOption('visible', value);
    }

    
    get width(): number {
        return this._getOption('width');
    }
    set width(value: number) {
        this._setOption('width', value);
    }

    protected get _optionPath() {
        return 'commonAxisSettings';
    }


    constructor(  parentOptionHost: NestedOptionHost,
             optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'dxo-common-axis-settings',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }, ]},
{type: NestedOptionHost, decorators: [{ type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'allowDecimals': [{ type: Input },],
'breakStyle': [{ type: Input },],
'color': [{ type: Input },],
'constantLineStyle': [{ type: Input },],
'discreteAxisDivisionMode': [{ type: Input },],
'endOnTick': [{ type: Input },],
'grid': [{ type: Input },],
'inverted': [{ type: Input },],
'label': [{ type: Input },],
'maxValueMargin': [{ type: Input },],
'minorGrid': [{ type: Input },],
'minorTick': [{ type: Input },],
'minValueMargin': [{ type: Input },],
'opacity': [{ type: Input },],
'placeholderSize': [{ type: Input },],
'setTicksAtUnitBeginning': [{ type: Input },],
'stripStyle': [{ type: Input },],
'tick': [{ type: Input },],
'title': [{ type: Input },],
'valueMarginsEnabled': [{ type: Input },],
'visible': [{ type: Input },],
'width': [{ type: Input },],
};
}


export class DxoCommonAxisSettingsModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    DxoCommonAxisSettingsComponent
  ],
  exports: [
    DxoCommonAxisSettingsComponent
  ],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
